module.exports = __webpack_public_path__ + "static/media/gold.a0accba6.webp";